import React from "react";
import { HowToPrint } from "../../how_tos/how_to_print/how_to_print.jsx";
import {
  Pricing,
  PricingPanel,
  PricingMessage,
} from "../../pricing/pricing.jsx";
import { LinkAsActionButtonA } from "pwm_global";
import { ActionButtonA } from "wm_global";

export const Printing = ({ location }) => {
  return (
    <article data-testid="printing-service-info">
      <div className="my-5 col-12 col-md-6 offset-md-3">
        {location.outOfOrder ? (
          <>
            <p className="text-center ooo-text-small">
              Cannot currently create order at this location because it is out
              of order.
            </p>
            <ActionButtonA
              addtlCssClasses="col-12 start-order-btn"
              onClick={() => null}
              disabled={true}
            >
              Start Print Order Here
            </ActionButtonA>
          </>
        ) : (
          <LinkAsActionButtonA
            url={`../../print/api/orders-3/${location.id}`}
            addtlCssClasses="col-12 start-order-btn"
          >
            Start Print Order Here
          </LinkAsActionButtonA>
        )}
      </div>

      <HowToPrint email={location.email} />
      <br />
      <br />

      {"PRINT" in location.pricing ? (
        <Pricing type="Print">
          <PricingPanel
            pricingFormatted={location.pricing.PRINT}
            color={false}
          />
          {location.hasColor ? (
            <PricingPanel
              pricingFormatted={location.pricing.PRINT}
              color={true}
            />
          ) : null}
        </Pricing>
      ) : null}
      <PricingMessage credits={location.credits} />
    </article>
  );
};
